/**
 * Service that interacts with the cookies.
 */
export default class CookieInteractor {
  /**
   * Constructor.
   *
   * @param {Object} Cookie
   */
  constructor(Cookie) {
    this.Cookie = Cookie
  }

  /**
   * Read a given value stored in the cookie.
   *
   * @param {String} name
   * @return {String}
   */
  read({ name }) {
    return this.Cookie.get(name)
  }

  /**
   * Write a value to the cookie.
   *
   * @param {String} name
   * @param {String} value
   * @param {Number} expires
   */
  write({ name, value, expires = 365 }) {
    this.Cookie.set(name, value, { expires })
  }
}
